export const sceneKeys = {
    all: (scenarioId: string) => ['scenes', scenarioId],
    find: (scenarioId: string, condition?: string) => ['scenes', scenarioId, condition]
} as const;
